"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mezzago": {
    "9054a69d": [{
      "hkey": "43c9b9b0",
      "slug": "orobona",
      "name": "Orobona",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-orobona": [{
      "hkey": "43c9b9b0",
      "slug": "orobona",
      "name": "Orobona",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a6b6ae8a": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "skipSearch": false
    }],
    "cascina-palazzina": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "26e3a872": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "skipSearch": false
    }],
    "castelet": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2cc9ae2c": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "skipSearch": false
    }],
    "pianta": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b306d6eb": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "skipSearch": false
    }],
    "torre": [{
      "hkey": "c5976539",
      "slug": "mezzago",
      "name": "Mezzago",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;